import Vue from "vue";
import Vuex from "vuex";

import user from './modules/user';
import global from './modules/global';
import log from './modules/log';
import message from './modules/message';
import thirdMsg from './modules/thirdMsg';
import pay from './modules/pay';
import handle from './modules/handle'
import activity from './modules/activity'
import redEnvelope from './modules/red-envelope'
import voucher from './modules/voucher'
import ks from './modules/ks';
import suspend from './modules/suspend';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    global,
    log,
    message,
    pay,
    handle,
    activity,
    redEnvelope,
    voucher,
    ks,
    suspend,
    thirdMsg
  }
});
